import isArray from 'lodash/isArray';

export function constructUrl(url, params = {}) {
    const paramsString = [];

    Object.keys(params).forEach((key) => {
        if (key in params && params[key] !== null && params[key] !== undefined) {
            if (isArray(params[key])) {
                for (let i = 0; i < params[key].length; i = i + 1) {
                    paramsString.push(`${key}[]=${params[key][i]}`);
                }
            } else {
                paramsString.push(`${key}=${params[key]}`);
            }
        }
    });

    if (paramsString.length > 0) {
        return `${url}?${paramsString.join('&')}`;
    }

    return url;
}


/**
 * @returns {string}
 */
export function systemEnvironmentApiUrl(forceLocahost = false, enforceStage = false) {
  // return 'https://system.rigips.cz';
  // return 'https://dev.api.calc.rigips.cz'
  if (location.hostname.indexOf('stage') === 0 || true === enforceStage) {
    return 'https://stage.system.rigips.cz';
  } else if (location.hostname.indexOf('localhost') === 0 && false === forceLocahost) {
    return 'http://system.rigips.lcl';
  }

  return 'https://system.rigips.cz';
}

export function documentationEnvironmentApiUrl(forceLocahost = false, enforceStage = false) {
  // return 'https://dev.api.calc.rigips.cz';
  if (location.hostname.indexOf('stage') === 0 || true === enforceStage) {
    return 'https://dev.api.calc.rigips.cz';
  } else if (location.hostname.indexOf('localhost') === 0 && false === forceLocahost) {
    return 'http://rigips.profi.lcl';
  }

  return 'https://api.profikalkulator.rigips.cz';
}



// WEBPACK FOOTER //
// ./src/helpers/url.js